const Seprator = ({ width='auto', height='auto' }) => {
    return (
        <div style={{ width: width, height: height,}}></div>
    );
}

export default Seprator;